import { render, staticRenderFns } from "./updateTransferredToAnotherPosition.vue?vue&type=template&id=23a06661&scoped=true&"
import script from "./updateTransferredToAnotherPosition.vue?vue&type=script&lang=ts&"
export * from "./updateTransferredToAnotherPosition.vue?vue&type=script&lang=ts&"
import style0 from "./updateTransferredToAnotherPosition.vue?vue&type=style&index=0&id=23a06661&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a06661",
  null
  
)

export default component.exports